/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Motivation_PlaceholderInputs */

const en_us2_profile_editors_motivation_placeholder = /** @type {(inputs: Profile_Editors_Motivation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One sentence is enough`)
};

const pt_br2_profile_editors_motivation_placeholder = /** @type {(inputs: Profile_Editors_Motivation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma frase já basta`)
};

const es_419_profile_editors_motivation_placeholder = /** @type {(inputs: Profile_Editors_Motivation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con una frase basta`)
};

const pt_pt2_profile_editors_motivation_placeholder = /** @type {(inputs: Profile_Editors_Motivation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma frase chega`)
};

const fr_fr2_profile_editors_motivation_placeholder = /** @type {(inputs: Profile_Editors_Motivation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une phrase suffit`)
};

const de_de2_profile_editors_motivation_placeholder = /** @type {(inputs: Profile_Editors_Motivation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Satz reicht`)
};

const it_it2_profile_editors_motivation_placeholder = /** @type {(inputs: Profile_Editors_Motivation_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basta una frase`)
};

/**
* | output |
* | --- |
* | "One sentence is enough" |
*
* @param {Profile_Editors_Motivation_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_motivation_placeholder = /** @type {((inputs?: Profile_Editors_Motivation_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Motivation_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_motivation_placeholder(inputs)
	if (locale === "es-419") return es_419_profile_editors_motivation_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_motivation_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_motivation_placeholder(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_motivation_placeholder(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_motivation_placeholder(inputs)
	return en_us2_profile_editors_motivation_placeholder(inputs)
});
export { profile_editors_motivation_placeholder as "profile-editors.motivation_placeholder" }